import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { Router, Link } from "@reach/router";
import Loadable from "react-loadable";
import FeatureToggle from "./routes/FeatureToggle";
import store from "./store";
import localConfig from "./common/localConfig";
import { TOASTER_LIMIT } from "./common/globalVariables";
import Loading from "./components/LoadingComponent";

// react-toastify dependecies
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "rc-pagination/assets/index.less";
// The following line needs to be here to trigger webpack to create the file
import ssu1 from "./css/idmp-master.less";
import ssu2 from "./css/wizard.less";
// The following line throws the following error if not commented out
// import ssu2 from "./css/idmp-icon-sets.less";

const RestrictedAccess = Loadable({
  loader: () => import("./components/RestrictedAccess"),
  loading: Loading,
});

const AudienceParent = Loadable({
  loader: () => import("./components/AudiencePlanner/AudienceParent"),
  loading: Loading,
});

const LoginPage = Loadable({
  loader: () => import("./components/Login/LoginPage"),
  loading: Loading,
});
const ChangePasswordPage = Loadable({
  loader: () => import("./components/Login/ChangePassword"),
  loading: Loading,
});
const ResetPasswordPage = Loadable({
  loader: () => import("./components/Login/ResetPassword"),
  loading: Loading,
});

const LoginNotification = Loadable({
  loader: () => import("./components/Login/LoginNotification"),
  loading: Loading,
});

const TaxonomyApiErrorReporting = Loadable({
  loader: () => import("./components/Reporting/TaxonomyApiErrorReporting"),
  loading: Loading,
});
const TaxonomyMetadata = Loadable({
  loader: () => import("./components/Tools/TaxonomyMetadata"),
  loading: Loading,
});

const Page = Loadable({
  loader: () => import("./components/Page"),
  loading: Loading,
});

const All = Loadable({
  loader: () => import("./routes/All"),
  loading: Loading,
});

const Home = Loadable({
  loader: () => import("./routes/Home"),
  loading: Loading,
});

const OnboardingParent = Loadable({
  loader: () => import("./components/OnboardingParent"),
  loading: Loading,
});

const ReportingParent = Loadable({
  loader: () => import("./components/Reporting/ReportingParent"),
  loading: Loading,
});

const DataActivationMetadataConfigurationParent = Loadable({
  loader: () =>
    import("./components/DataActivationMetadataConfigurationParent"),
  loading: Loading,
});

const SyndicationParent = Loadable({
  loader: () => import("./components/syndication/SyndicationParent"),
  loading: Loading,
});

const RawDataAttributeParent = Loadable({
  loader: () =>
    import("./components/RawDataAttributeBuilder/RawDataAttributeParent"),
  loading: Loading,
});

const AudienceExplorerParent = Loadable({
  loader: () => import("./components/AudienceExplorerParent"),
  loading: Loading,
});

const Iframing = Loadable({
  loader: () => import("./components/reusable/Iframing.component"),
  loading: Loading,
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      {/* <LoginPage path="/login/" /> */}
      <RestrictedAccess privilege={"IdentityHomepage"}>
        <Router basepath={`/${localConfig.contextPath}`}>
          {/* <All path="/all/" /> */}
          <LoginPage path="/login" />
          <ChangePasswordPage path="/login/change-password"/>
          <ResetPasswordPage path="/login/reset-password"/>
          <Page path="/">
            <Home path="/" />
            <AudienceParent path="audience/*" />
            <AudienceExplorerParent path="explorer/" />
            <Iframing
              path="taxonomy/licensing"
              srcPath="/#/audience/licensing-dashboard"
              containerClass="licensing"
              scrolling="no"
            />
            <Iframing
              path="elementone/"
              srcPath="/#/elementone"
              containerClass="elementone"
              scrolling="no"
            />
            <Iframing
              path="insights/"
              srcPath="/#/insights/trends"
              containerClass="insights"
              scrolling="yes"
            />
            <Iframing
              path="reports/"
              srcPath="/#/reports/index"
              containerClass="reports"
              scrolling="yes"
            />
            <Iframing
              path="manage/"
              srcPath="/manage"
              containerClass="manage"
              scrolling="yes"
            />
            <Iframing
              path="integrations/"
              srcPath="/manage/#/admin/integrations"
              containerClass="integrations"
              scrolling="yes"
            />
            <OnboardingParent path="onboarding/*" />
            <ReportingParent path="audience/reports/*" />
            <ReportingParent path="onboarding/reports/*" />
            <ReportingParent path="/raw-data-attributes/reports/*" />
            <RawDataAttributeParent path="raw-data-attributes/*" />
            <DataActivationMetadataConfigurationParent path="data-activation/*" />
            <SyndicationParent path="syndication/*" />
            <LoginNotification path="loginNotification/" />
            <TaxonomyApiErrorReporting path="taxonomy/reporting"/>
            <TaxonomyMetadata path="taxonomy/taxonomy-metadata-search"/>
          </Page>
          <FeatureToggle path="/feature-toggle" />
        </Router>
        <ToastContainer limit={TOASTER_LIMIT} />
      </RestrictedAccess>
    </Provider>
    {/* , */}
  </React.StrictMode>,
  document.getElementById("root")
);
